import React from "react"
import Image from "../general/Image"
import { Typography } from "@novaescola/eva-react-v2/lib/Typography"

export function PartnersAlana({ section }) {
	return (
		<section
			className="partners eva-bg-inst-500 container-fluid"
			style={{ backgroundColor: section.body?.backgroundColor }}
		>
			<div className="container" id="alana">
				<div className="blocks eva-text-center">
					<div className="d-flex js-center">
						<Image
							remoteImage="https://s3.amazonaws.com/lms.novaescola.org.br/logos/6c4febb0-0a6f-11f0-adba-5ba98d6aa540.png"
							fallbackImageUrl="https://s3.amazonaws.com/lms.novaescola.org.br/logos/6c4febb0-0a6f-11f0-adba-5ba98d6aa540.png"
							alt="Educação baseada na natureza"
						/>
					</div>

					<Typography
						variant="title"
						size={4}
						asChild
						className="eva-mb-03 eva-mt-02"
						style={{ color: section.body?.textColor }}
					>
						<p>Iniciativa</p>
					</Typography>

					<div className="row js-center ai-center">
						<div className="col-auto">
							<a
								href="https://www.unicef.org/brazil/"
								target="_blank"
								rel="noReferrer"
								className="image"
							>
								<Image
									remoteImage="https://s3.amazonaws.com/lms.novaescola.org.br/logos/cd368cf0-0a6e-11f0-adba-5ba98d6aa540.png"
									fallbackImageUrl="https://s3.amazonaws.com/lms.novaescola.org.br/logos/cd368cf0-0a6e-11f0-adba-5ba98d6aa540.png"
									alt="Unicef"
								/>
							</a>
						</div>
						<div className="col-auto">
							<a
								href="https://www.unicef.org/brazil/entrenoclimaunicef"
								target="_blank"
								rel="noReferrer"
								className="image"
								id="escola-mais-natureza"
							>
								<Image
									remoteImage="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/d91556a0-0a6e-11f0-adba-5ba98d6aa541.webp"
									fallbackImageUrl="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/d91556a0-0a6e-11f0-adba-5ba98d6aa541.webp"
									alt="Entre no Clima - Unicef"
								/>
							</a>
						</div>
					</div>

					<Typography
						variant="title"
						size={4}
						asChild
						className="eva-mb-03 eva-mt-02"
						style={{ color: section.body?.textColor }}
					>
						<p>Parceria institucional e de implementação</p>
					</Typography>

					<div className="row js-center ai-center">
						<div className="col-auto">
							<a
								href="https://alana.org.br/"
								target="_blank"
								rel="noReferrer"
								className="image"
							>
								<Image
									remoteImage="https://s3.amazonaws.com/lms.novaescola.org.br/logos/975efb30-0a6e-11f0-adba-5ba98d6aa540.png"
									fallbackImageUrl="https://s3.amazonaws.com/lms.novaescola.org.br/logos/975efb30-0a6e-11f0-adba-5ba98d6aa540.png"
									alt="Alana"
								/>
							</a>
						</div>
						<div className="col-auto">
							<a
								href="https://escolamaisnatureza.com.br/"
								target="_blank"
								rel="noReferrer"
								className="image"
							>
								<Image
									remoteImage="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/8727faf0-0a6e-11f0-adba-5ba98d6aa541.png"
									fallbackImageUrl="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/8727faf0-0a6e-11f0-adba-5ba98d6aa541.png"
									alt="Escola + Natureza"
								/>
							</a>
						</div>
					</div>

					<Typography
						variant="title"
						size={4}
						asChild
						className="eva-mb-03 eva-mt-02"
						style={{ color: section.body?.textColor }}
					>
						<p>Parceria estratégica</p>
					</Typography>

					<div className="row js-center ai-center">
						<div className="col-auto">
							<a
								href="https://www.neoenergia.com/"
								target="_blank"
								rel="noReferrer"
								className="image"
							>
								<Image
									remoteImage="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/80181790-8452-11ec-b976-8ffd4358304a.png"
									fallbackImageUrl="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/80181790-8452-11ec-b976-8ffd4358304a.png"
									alt="NeoEnergia"
								/>
							</a>
						</div>
						<div className="col-auto">
							<a
								href="https://www.gov.br/aneel/pt-br"
								target="_blank"
								rel="noReferrer"
								className="image"
							>
								<Image
									remoteImage="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/addfa2b0-04e1-11ec-bc5a-a3560206ad7g.png"
									fallbackImageUrl="https://s3.amazonaws.com/uploads.lms.novaescola.org.br/logos/addfa2b0-04e1-11ec-bc5a-a3560206ad7g.png"
									alt="ANEEL"
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
